import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ec834a12&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=ec834a12&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=ec834a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec834a12",
  null
  
)

export default component.exports